module.exports = __webpack_public_path__ + "img/Care1Mobile.26896b76.png";